/// <reference path="./env.d.ts" />
// ============================================
// @gs/config/browser — Vite / navigateur uniquement (import.meta.env)
// Ne pas importer ce module depuis les serveurs bundlés en CJS (esbuild).
// ============================================
import { clientEnvSchema, } from './index.js';
let _clientConfig = null;
function formatZodIssues(err) {
    return err.issues.map((e) => `${e.path.join('.') || '(root)'}: ${e.message}`).join('; ');
}
/**
 * Valide les variables Vite (lazy, cache).
 * À utiliser uniquement depuis le frontend (Vite).
 */
export function getClientConfig() {
    if (_clientConfig)
        return _clientConfig;
    const raw = {
        VITE_AZURE_AD_CLIENT_ID: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
        VITE_AZURE_AD_TENANT_ID: import.meta.env.VITE_AZURE_AD_TENANT_ID,
        VITE_AZURE_AD_REDIRECT_URI: import.meta.env.VITE_AZURE_AD_REDIRECT_URI,
        VITE_API_URL: import.meta.env.VITE_API_URL,
    };
    const result = clientEnvSchema.safeParse(raw);
    if (!result.success) {
        console.error(`[gs/config] Variables Vite invalides : ${formatZodIssues(result.error)}`);
        _clientConfig = {
            VITE_AZURE_AD_CLIENT_ID: '',
            VITE_AZURE_AD_TENANT_ID: '',
            VITE_AZURE_AD_REDIRECT_URI: undefined,
            VITE_API_URL: 'http://localhost:3001',
        };
        return _clientConfig;
    }
    _clientConfig = result.data;
    return _clientConfig;
}
/**
 * Configuration agrégée pour le navigateur (MSAL, API URL, etc.).
 * @deprecated Préférer les getters ciblés ; conservé pour @gs/auth.
 */
export function getConfig() {
    const c = getClientConfig();
    const mode = import.meta.env.MODE;
    const nodeEnv = mode === 'production' ? 'production' : mode === 'test' ? 'test' : 'development';
    return {
        sql: {},
        auth: {
            clientId: c.VITE_AZURE_AD_CLIENT_ID,
            tenantId: c.VITE_AZURE_AD_TENANT_ID,
            redirectUri: c.VITE_AZURE_AD_REDIRECT_URI && c.VITE_AZURE_AD_REDIRECT_URI !== ''
                ? c.VITE_AZURE_AD_REDIRECT_URI
                : window.location.origin,
            scopes: ['User.Read', 'openid', 'profile', 'email'],
        },
        storage: {},
        apiUrl: c.VITE_API_URL,
        nodeEnv,
    };
}
//# sourceMappingURL=browser.js.map